import { type Locale, type TranslationValues } from '@shared/config/i18n'
import { dayjs, DEFAULT_TIMEZONE } from '@shared/libs/dayjs'

export const MAX_BLOCKED_TUTORS = 5

type Translate = (key: string, values?: TranslationValues) => string

const DATE_FORMAT_BY_LOCALE = {
  ko: 'YYYY. MM. DD',
  en: 'MMM D, YYYY',
  ja: 'YYYY. MM. DD',
} satisfies Record<Locale, string>

export const formatMeetDate = (
  dateStr: string,
  timezone: string = DEFAULT_TIMEZONE,
  locale: Locale = 'ko',
  t?: Translate,
) => {
  const date = dayjs.utc(dateStr).tz(timezone)
  const formattedDate = date.locale(locale).format(DATE_FORMAT_BY_LOCALE[locale])

  if (t) {
    return t('tutorExclusion.meetDate', { date: formattedDate })
  }

  return formattedDate
}

export const SLOT_FULL_DIALOG = {
  REDIRECT_PATH: '/my-podo/tutor-exclusion',
} as const
